import platformHelpers from 'Models/uiConfig/platformHelpers';
import { onStoragePermissionsChanged, setStoragePermissionsSettled } from 'Utils/browserStorage';

const storagePermissionsSettled = Promise.resolve(
  platformHelpers.initializePlatformStorage(onStoragePermissionsChanged),
);
setStoragePermissionsSettled(storagePermissionsSettled);

Promise.race([storagePermissionsSettled, beforeThemeDomContentLoaded()])
  .then(() => import('./runInitFunc'))
  .then(() => import('./application'));

function beforeThemeDomContentLoaded(): Promise<void> {
  const navigation = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming | undefined;
  if (document.readyState !== 'loading' && navigation?.domContentLoadedEventStart !== 0) {
    return Promise.resolve();
  }
  // Theme DOMContentLoaded handlers call window.Convermax; a capturing window listener runs first.
  return new Promise((resolve) => {
    window.addEventListener('DOMContentLoaded', () => resolve(), { capture: true, once: true });
  });
}
